import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { PrimaryButton } from '@scts-ui/component-library';
import { ExcelExportProps } from '@scts/models'

function ExcelExport<TItem>(props: ExcelExportProps<TItem>): JSX.Element {

  const createFileName = (prefix: string) => {
    const currentDateTime: string = new Date().toLocaleString();
    let dateToFileName: string = currentDateTime
                                  .replace(/\//g, "")
                                  .replace(/,/g, "_")
                                  .replace(/ /g, "")
                                  .replace(/:/g, "");
    dateToFileName = dateToFileName.substring(0, 4) + dateToFileName.substring(6, dateToFileName.length);
    return(prefix + "_" + dateToFileName);
  };

  const exportToExcel = () => {
    let data: TItem[] = props.data;

    //Create worksheet object from the data
    const worksheet = XLSX.utils.json_to_sheet(data);

    //Set excel table headers
    XLSX.utils.sheet_add_aoa(worksheet, [props.excelExportParameters.tableHeaders], { origin: "A1" });

    //Setting the width of the table columns
    const nrOfColumns = props.excelExportParameters.tableHeaders.length;
    if ( !worksheet["!cols"] ) {
      worksheet["!cols"] = [];
    }
    
    for(let i = 0; i < nrOfColumns; i++ ) {
      worksheet["!cols"][i] = {wch: props.excelExportParameters.tableColumnsWidth[i]};
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], {type: 'application/octet-stream'});
    saveAs(blob, `${createFileName(props.excelExportParameters.typeOfData)}.xlsx`);
  };

  return (
    <PrimaryButton onClick={exportToExcel} buttonText={'Download Table'} />
  );
}

export default ExcelExport;